package com.example.hukakmp.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.example.hukakmp.data.AuthState
import com.example.hukakmp.viewmodel.LoginViewModel

private val HukaLoginTop = Color(0xFF9EDCF3)
private val HukaLoginBottom = Color(0xFF0E5E73)
private val HukaLoginCard = Color(0xFF1B3039)
private val HukaLoginAccent = Color(0xFF8FD8F3)
private val HukaLoginText = Color(0xFFEAF8FF)

@Composable
fun LoginScreen(
    authState: AuthState,
    loginUiState: LoginViewModel.LoginUiState,
    showGoogleSignIn: Boolean,
    onGoogleSignIn: () -> Unit,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(
                Brush.verticalGradient(
                    colors = listOf(HukaLoginTop, HukaLoginBottom),
                ),
            ),
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .verticalScroll(rememberScrollState())
                .padding(horizontal = 20.dp, vertical = 28.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
        ) {
            Surface(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = 430.dp),
                shape = RoundedCornerShape(24.dp),
                color = HukaLoginCard,
                shadowElevation = 18.dp,
            ) {
                Column(
                    modifier = Modifier.padding(horizontal = 28.dp, vertical = 34.dp),
                    horizontalAlignment = Alignment.CenterHorizontally,
                ) {
                    HukaLogoMark(modifier = Modifier.size(116.dp))

                    Spacer(Modifier.height(18.dp))
                    Text(
                        text = "Huka",
                        color = HukaLoginAccent,
                        style = MaterialTheme.typography.headlineMedium,
                        fontWeight = FontWeight.Bold,
                    )
                    Text(
                        text = "Tu compañera de pesca",
                        color = HukaLoginText.copy(alpha = 0.78f),
                        style = MaterialTheme.typography.bodyMedium,
                        modifier = Modifier.padding(top = 4.dp),
                    )

                    Spacer(Modifier.height(28.dp))

                    loginUiState.error?.let {
                        AuthFeedback(message = it)
                        Spacer(Modifier.height(14.dp))
                    }

                    if (authState is AuthState.Error && loginUiState.error == null) {
                        AuthFeedback(message = authState.message)
                        Spacer(Modifier.height(14.dp))
                    }

                    Button(
                        onClick = onGoogleSignIn,
                        enabled = showGoogleSignIn && !loginUiState.isLoading,
                        modifier = Modifier.fillMaxWidth().height(54.dp),
                        shape = RoundedCornerShape(28.dp),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = HukaLoginAccent,
                            contentColor = Color(0xFF102A35),
                            disabledContainerColor = HukaLoginAccent.copy(alpha = 0.55f),
                            disabledContentColor = Color(0xFF102A35).copy(alpha = 0.62f),
                        ),
                    ) {
                        if (loginUiState.isLoading) {
                            CircularProgressIndicator(
                                modifier = Modifier.size(20.dp),
                                strokeWidth = 2.dp,
                                color = Color(0xFF102A35),
                            )
                            Spacer(Modifier.width(10.dp))
                            Text("Conectando con Google…", fontWeight = FontWeight.SemiBold)
                        } else {
                            Surface(
                                modifier = Modifier.size(24.dp),
                                shape = CircleShape,
                                color = Color.White,
                            ) {
                                Box(contentAlignment = Alignment.Center) {
                                    Text(
                                        text = "G",
                                        color = Color(0xFF4285F4),
                                        style = MaterialTheme.typography.labelMedium,
                                        fontWeight = FontWeight.Bold,
                                    )
                                }
                            }
                            Spacer(Modifier.width(10.dp))
                            Text("Continuar con Google", fontWeight = FontWeight.Bold)
                        }
                    }

                    if (!showGoogleSignIn) {
                        Text(
                            text = "El acceso con Google no está disponible en esta plataforma.",
                            style = MaterialTheme.typography.bodySmall,
                            color = Color(0xFFFFB4AB),
                            textAlign = TextAlign.Center,
                            modifier = Modifier.padding(top = 12.dp),
                        )
                    }

                    Spacer(Modifier.height(18.dp))
                    Text(
                        text = "Iniciá sesión para guardar tus partes,\nlogros y récords personales 🎣",
                        style = MaterialTheme.typography.bodySmall,
                        textAlign = TextAlign.Center,
                        color = HukaLoginText.copy(alpha = 0.62f),
                    )
                }
            }
        }
    }
}

@Composable
private fun AuthFeedback(message: String) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(12.dp),
        color = Color(0xFF5A2A2A),
    ) {
        Text(
            text = message,
            modifier = Modifier.padding(12.dp),
            style = MaterialTheme.typography.bodySmall,
            color = Color(0xFFFFDAD6),
            textAlign = TextAlign.Center,
        )
    }
}
